/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingTableSection_project = {
    readonly id: string;
    readonly companyProjectId: number | null;
    readonly invoices: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly companyInvoiceId: number | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ProjectInvoicingTable_project" | "InvoiceFilterButton_project">;
    readonly " $refType": "ProjectInvoicingTableSection_project";
};
export type ProjectInvoicingTableSection_project$data = ProjectInvoicingTableSection_project;
export type ProjectInvoicingTableSection_project$key = {
    readonly " $data"?: ProjectInvoicingTableSection_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectInvoicingTableSection_project">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvoicingTableSection_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InvoiceTypeConnection",
      "kind": "LinkedField",
      "name": "invoices",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InvoiceType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyInvoiceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectInvoicingTable_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceFilterButton_project"
    }
  ],
  "type": "ProjectType"
};
})();
(node as any).hash = '019e78516807ab80d6a8f47784ff4ece';
export default node;
